import { authUrl } from '@/api/types';

export function userInfoUrl() {
  return `${authUrl}/user-info`;
}

export function userPulseUrl() {
  return `${authUrl}/user-pulse`;
}
